import { createTheme } from "@mui/material";

export const palette = {
  primary: {
    main: "#0583b8",
  },
  background: {
    default: "#dfefee",
  },
  text: { primary: "#333333" },
};

const theme = createTheme({ palette });

export default theme;
